//将文本框中的list 填充到fileList中去
function FillFileListByImgUrls(imgUrls, params) {
  var fileList = [];
  imgUrls = imgUrls.trim();
  var imgUrlList = imgUrls.split("\n");
  imgUrlList.forEach((item) => {
    var newItem = JSON.parse(JSON.stringify(params));
    var link = item.trim();
    if (link.indexOf(".jpg_.webp") > 0) link = link.replace(".jpg_.webp", ".jpg");
    if (link.indexOf(".kaogujia.com") > 0) link = link.replace(".webp", ".png");
    newItem.params.keyword = link;
    fileList.push(newItem);
  });

  return fileList;
}

export default { FillFileListByImgUrls };
